import type { Layout } from '../../data/types';
import type { Vec2 } from '../../geo/types';
import type { BakedCrowd } from './crowd/crowdPlan';
import type { Ground } from './crowd/walkNet';
import { planNeighbourhoodPlay } from './neighbourhoodPlay';
import type { LifeEntrance } from './types';

export const PLAY_KINDS = ['hoop', 'top', 'stilts', 'marbles', 'knuckles'] as const;
export type PlayKind = (typeof PLAY_KINDS)[number];

export interface StreetPlayGroup {
  readonly kind: PlayKind;
  readonly streetId: string;
  readonly name: string;
  readonly home: LifeEntrance;
  readonly center: Vec2;
  readonly heading: number;
  readonly route: readonly Vec2[];
}

/** The toys share safe neighbourhood routes; no playing child is placed on a trade square. */
export function planStreetPlay(
  layout: Layout,
  crowd: BakedCrowd,
  ground: Ground
): StreetPlayGroup[] {
  return planNeighbourhoodPlay(layout, crowd, ground).map((place, i) => ({
    ...place,
    kind: PLAY_KINDS[i % PLAY_KINDS.length]!,
  }));
}
